import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["body"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { pipe } from 'fp-ts/function';
import * as IO from 'fp-ts/IO';
import * as O from 'fp-ts/Option';
import { useEffect, useState } from 'react';
import FroalaStyles from './froala-styles';
import { jsx as _jsx } from "react/jsx-runtime";
export var DangerouslySetInnerHTML = function DangerouslySetInnerHTML(_ref) {
  var body = _ref.body,
      boxProps = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(null),
      el = _useState[0],
      setEl = _useState[1];

  useEffect(function () {
    pipe(el, O.fromNullable, O.map(function (current) {
      return current.querySelectorAll('video');
    }), O.map(function (x) {
      return _toConsumableArray(x);
    }), O.traverse(IO.Applicative)(IO.traverseArray(function (element) {
      return function () {
        element.setAttribute('controls', 'true');
      };
    })))();
  }, [el]);
  return /*#__PURE__*/_jsx(FroalaStyles, _objectSpread(_objectSpread({
    ref: setEl
  }, boxProps), {}, {
    dangerouslySetInnerHTML: {
      __html: body
    },
    "data-element": "FroalaStyles",
    "data-component": "DangerouslySetInnerHTML",
    "data-source-file": "index.tsx"
  }));
};